// Copyright © 2019-2026 Focal Systems. All rights reserved.

interface WifiCredentials {
  authMode: number;
  ssid: string;
  password: string;
  username?: string | null;
}

// All fields combined make an entry — the same SSID may be listed again with other credentials or auth
// mode — so only a repeat of every one of them counts. A blank username is no username. Mirrors the
// backend's `check_wifi_fallbacks_unique`, which rejects the save outright.
function wifiIdentity(wifi: WifiCredentials): string {
  return JSON.stringify([wifi.authMode, wifi.ssid, wifi.password, wifi.username || null]);
}

/** Indexes of fallbacks that repeat the primary network or an earlier fallback. */
export function findDuplicateWifiFallbacks(primary: WifiCredentials, fallbacks: WifiCredentials[]): number[] {
  const seen = new Set([wifiIdentity(primary)]);
  const duplicates: number[] = [];
  fallbacks.forEach((fallback, index) => {
    const identity = wifiIdentity(fallback);
    if (seen.has(identity)) {
      duplicates.push(index);
    }
    seen.add(identity);
  });
  return duplicates;
}
